export default __webpack_public_path__ + "static/media/img-0401-serbia-premium-face.9ae1409b.png";